import React from 'react';

export const isEnterKey = (event: React.KeyboardEvent<HTMLElement>) => {
    return event && event.code === 'Enter';
};
